import { Skeleton, Typography } from "@mui/material";

const customStyles = {
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "fit-content",
    flexDirection: "column",
    padding: "30px 20px",
    "& > span": {
      marginBottom: "12px",
      width: "100%",
      height: "30px",
    },
  },
};

function TableSkeleton() {
  return (
    <Typography component="div" sx={customStyles.root}>
      <Skeleton variant="rectangular" />
      <Skeleton variant="rectangular" />
      <Skeleton variant="rectangular" />
      <Skeleton variant="rectangular" />
      <Skeleton variant="rectangular" />
    </Typography>
  );
}

export default TableSkeleton;
